module.exports = [{"title":"Dashboard","url":"/dashboard"},{"title":"Draft","url":"/draft"},{"title":"Shows","url":"/shows"},{"title":"Manage","items":[{"title":"Roster","url":"/roster"},{"title":"Brands","url":"/brands"},{"title":"Championships","url":"/championships"}]},{"title":"Create","items":[{"title":"Match","url":"/create-match"},{"title":"Show","url":"/create-show"},{"title":"Battle Royal","url":"/battle-royal"}]},{"title":"Settings","url":"/settings"}]


//////////////////
// WEBPACK FOOTER
// ./src/layouts/site/links.json
// module id = 156
// module chunks = 16